module.exports = __webpack_public_path__ + "static/media/contact-banner.0c2227fd.svg";